import { render, staticRenderFns } from "./TestGuidanceView.vue?vue&type=template&id=71ad096c&scoped=true"
import script from "./TestGuidanceView.vue?vue&type=script&lang=js"
export * from "./TestGuidanceView.vue?vue&type=script&lang=js"
import style0 from "./TestGuidanceView.vue?vue&type=style&index=0&id=71ad096c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad096c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
